import { render, staticRenderFns } from "./SummaryManagementNonClaim.vue?vue&type=template&id=57682a94&scoped=true"
import script from "./SummaryManagementNonClaim.vue?vue&type=script&lang=js"
export * from "./SummaryManagementNonClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57682a94",
  null
  
)

export default component.exports